import React from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";

export const Centered = props => {
    return (<div className={classNames(styles.container, props.rootClassName)}>
        <div className={classNames(styles.content, props.className, (props.variant && styles[props.variant])?styles[props.variant]:'')}>{props.children}</div>
    </div>);
}
